export default function CommonChip({ text = "NEW", customClass = '' }: { text?: string; customClass?: string; }) {
  return <div className={`ml-6 bg-[#397EF5] px-4 text-12 text-white rounded-[4px] ${customClass}`}>{text}</div>
}